import { Sheet } from "@mui/joy";

export function ErrorBlock({ width = "435px", py = "90px" }) {
    return <Sheet variant="outlined" color="danger" sx={{ p: 4, width, py, textAlign: "center" }}>{"Can't load block data"}</Sheet>
}
